export default __webpack_public_path__ + "static/media/customers.8a66a8e4.svg";